export default __webpack_public_path__ + "static/media/30.ce88ea4d.png";